<template>
  <div class="close-after-sales">
    <div class="close-after-sales-content">
      <div class="close-sales-title">
        <div class="medium">
          {{message.userKey==='Platform'?"Platform":message.username}}
          </div>
        <div>{{message.createAt}}</div>
      </div>
      <div class="close-sales-content">
        <div>Service order is closed</div>

        <div v-if="message.status!==34">
          <span v-if="message.userKey==='Platform'">The brand refuses Service Order</span>
          <span v-else-if="message.userKey">The Retailer cancels after-sale order</span>
        </div>
        <div v-if="message.status===34">
          The platfrom (ShopVidi) Arbitration has closed Service Order
        </div>
        <div v-if="serviceOrder['userId']!=message.userKey">
          {{message.userKey?'Arbitration reason:':''}} {{message.reason}}
        </div>


      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      default: () => { return {} },
      type: Object
    },
    serviceOrder: {
      type: Object,
      default: function() {}
    }
  }
}
</script>

<style lang="less" scoped>
.close-after-sales{
  padding: 20px;
  line-height: 32px;
}
.close-sales-title{
  display: flex;
  justify-content: space-between;
}
.medium{
  font-family: Satoshi-medium;
}
.close-after-sales-content{
  border-bottom: 1px solid #e1e1e1;
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/service-order/components/history-list/close-after-sales.vue